var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.customerApplicationList,
          headers: _vm.headers,
          loading: _vm.customerApplicationGetting,
          dense: ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _c("td", [_vm._v(_vm._s(item.category.description || null))]),
                  _c("td", [_vm._v(_vm._s(item.email))]),
                  _c("td", [_vm._v(_vm._s(item.date_of_birth.dateFormat({})))]),
                  _c("td", [_vm._v(_vm._s(item.contact_no1))]),
                  _c("td", [_vm._v(_vm._s(item.contact_no2))]),
                  _c("td", [_vm._v(_vm._s(item.character_ref))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "light-green darken-1",
                            dark: "",
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.showCustomerApplication(item)
                            }
                          }
                        },
                        [_c("span", [_vm._v("Show")])]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }